<template>
  <div class="map">
    <my-header title="地图" />
  </div>
</template>

<script>
import myHeader from "@/components/header"
export default {
  data () {
    return {
    }
  },
  components: {
    myHeader
  },
  methods: {
  },
  mounted () {
    setTimeout(() => {
      this.common.openMap(this.$route.params.marks, this.$route.params.flag);
    }, 500);
  },
  beforeDestroy () {
	  plus.webview.close("mapsId");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#showMap{
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
}
button{
  font-size: 1.5em;
  margin: 10px;
  position: relative;
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/components/maps.vue